import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0081 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="半休は有給取得義務の5日に含められる？半休の日の残業代、残業と時間休を併用する場合は？" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2025.06.19</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        半日有休は暦日単位での取得が進まない企業にとって取得にあたっての心理的なハードルを下げる効果があり、一定程度の需要があります。ただし、法令上、半日単位の取得は多くの論点にも波及することから労務管理上注意しなければならないことを解説します。
      </p>
      <img src="/images/column/details/c0081.jpg" alt="キンクラコラム画像81" />
      <div id="toc1">
        <h1>有給取得義務5日と半休</h1>
      </div>
      <p>
        2019年4月1日以降、年10日以上の有給休暇を付与される場合には当該付与日から1年の間に5日の取得が義務付けられています。本来、年次有給休暇は暦日での取得が原則ではありますが、
        <span>
          暦日単位での取得を阻害しない範囲内で半日単位の取得については0.5日として、5日の中に含めることが可能
        </span>
        とされています。
      </p>

      <div id="toc2">
        <h1>半休の日の残業代について</h1>
      </div>
      <p>
        所定労働時間は企業によって異なり、午前と午後で労働時間が同じケースも想定されます（例えば8時～12時の4時間が午前の労働時間で休憩明け後13時から17時も同じく4時間が午後の労働時間）。他方、このようなケースばかりでなく、午前と午後で労働時間が異なるケースも想定されます（例えば9時～12時の3時間が午前の労働時間で休憩明け後13時から18時の5時間が午後の労働時間）。
        <br />
        <br />
        「半休」とは労働者の請求により午前と午後いずれか一方の労務提供が免除されることです。もちろん、賃金を保障した状態で休暇を付与しなければなりませんので、欠勤控除をかけることは許されません。
        <br />
        <br />
        肝心の「残業代」については、労働基準法上、法定労働時間を超えた部分の労働時間（1日8時間・週40時間）に対して通常の賃金に対して1.25倍の割増賃金を支給することが最低基準となります。ただし、
        <span>
          半休を取得した場合、一部の労働はあるものの、免除されている時間があり、当該半休を取得した時間は「実労働時間」からは除くこと
        </span>
        となります。すなわち、通常の賃金については減額されることはありませんが、残業代の算定にあたっての労働時間の通算はおこなわないこととなります。
        <br />
        <br />
        これは固定労働時間にあたって限定された考え方ではなく、フレックスタイム制においても同様の考え方が採用されています。
        <br />
        <br />
        他方、就業規則や賃金規程上、
        <span>
          「終業時刻」を超えた以降の労働時間は残業代として支給すると規定されている場合は話が別
        </span>
        です。例えば終業時刻が18時の会社とし、午前に半休を取得したとしましょう。午前中は半休によって労働はなかったため、午後のみで8時間を超えることは（深夜に跨ったような場合を除き）想定し難いですが、
        <span>
          単に「終業時刻」を超えた以降の労働時間は残業代を支給すると規定している場合は、残業代の支給が必要
        </span>
        となります。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>
          時間休を併用する場合の有給残数管理（半休取得後の残0.5日の日数を、時間有給としても消化可能など）
        </h1>
      </div>
      <p>
        時間単位の有給は事業主側に応ずる義務はありませんが、労使双方に導入するほうがメリットは大きい場合、労使協定を締結し、年5日の範囲内で取得が可能となります。ただし、労務管理上、最も管理が煩雑になる論点として、端数処理の管理です。半日の場合、0.5日として処理することで足りますので、そこまで煩雑になることはありません。他方、時間単位も導入するとなれば0.5以下の処理や0.5を上回る処理も日常的に発生しますので、有給休暇の残日数管理を進めていくにあたっては一定の習熟が求められます。
        <br />
        <br />
        他方、
        <span>
          0.5日として時間単位の取得がある場合、「半休」として処理するのか「時間単位」として処理するのかの複数の選択肢
        </span>
        が考えられます。この場合、
        <span>原則としては労働者不利とならないように配慮</span>
        すべきではありますが、時間単位が既に年5日達している場合は選択の余地がありません。反対に年5日に達していない場合についてはどちらの対応方法で進めるかを検討し、周知しておかなければなりません。
        <br />
        <br />
        また、派生する論点として、有給休暇管理簿への記載と賃金計算への紐づけも必要となります。特に契約形態が時間給の労働者の場合は有給付与単位が賃金額に密接に紐づくため、誤った計算となると支給額だけに留まらず雇用保険料にも影響が及びます。
      </p>

      <div id="toc4">
        <h1>有給取得義務化について</h1>
      </div>
      <p>
        2019年4月1日以降、年10日以上の有給休暇が付与されている労働者に対しては当該付与日から1年内の間に5日の取得が義務化されていますが、
        <span>
          「時間単位」で取得した分に関しては5日に含めることができません。
        </span>
        他方、
        <span>「半休」については、「0.5日」として含めることができます。</span>
        よって、事業主目線では前述のケースで「半日」取得した際で半休としても時間単位としても処理でき得る場合は法令違反回避の意味でも半休として処理できるに越したことはありません。もし、そのような制度とする場合には労働者に趣旨を説明しておくことが有用です。
      </p>

      <div id="toc5">
        <h1>最後に</h1>
      </div>
      <p>
        半休については次の2点が重要です。1点目は半休を取得した時間分は労働したものとみなすという性質上、残業代の計算の際に残りの労働時間と通算して、「実労働時間に含めて計算すべき」と考えられがちであること、2点目は半休と時間単位の双方での取得が想定される場合には、制度導入前に会社としての意思決定が必要であることです。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0081
